/* @ngInject */
function HomePostsController ($scope, $rootScope, HomeService, ModalService, SliderService, SegmentService) {
  const api = {
    _handleSuccessGetPosts
  }
  this.getApi = () => api

  activate()

  function activate () {
    HomeService.getHomePosts(5).then(api._handleSuccessGetPosts)

    $scope.isFirstWidget = !$scope.features['WORKFLOW.ACCESS']
  }

  function _handleSuccessGetPosts (posts) {
    $scope.posts = posts.rows
    $scope.countAll = posts.count
  }

  $scope.openPostDetails = function (postId) {
    SegmentService.track('announcement-widget-click')

    if ($rootScope.isDesktop) {
      ModalService.showModal({
        templateId: 'newPost.html',
        templateUrl: '/posts/dialogs/post/post-dialog.html?$$REVISION$$',
        destroyable: true,
        closable: true,
        data: {
          _postId: postId,
          _editMode: false
        }
      }).then(() => {
        activate()
      })
    } else {
      SliderService.setState('post-slider', 'open', {
        _postId: postId,
        _editMode: false
      })
    }
  }
}

export { HomePostsController }
